/** Plain black-on-white: highest contrast for every scanner. */
export const QR_COLORS = { dark: '#000000', light: '#ffffff' };
